<article>
  <table mat-table [dataSource]="adsTypes()" class="mat-table-container">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Type de publicité</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="mediaType">
      <th mat-header-cell *matHeaderCellDef>Média</th>
      <td mat-cell *matCellDef="let element">
        {{ element.mediaType | mediaType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mat-table-container__actions-header"
      >
        Actions
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__actions"
      >
        <button
          type="button"
          (click)="openEditDialog(element)"
          matTooltip="Modifier"
        >
          <img [lazyLoad]="'assets/icons/pen-to-square.svg'" alt="edit" />
        </button>
        <button
          (click)="openDeleteDialog(element)"
          type="button"
          matTooltip="Supprimer"
        >
          <img [lazyLoad]="'assets/icons/trash.svg'" alt="trash" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
